import Button, { type ButtonProps } from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import type { FC } from 'react';
import { NAVY, RADIUS_COIN, YELLOW } from 'styles/tokens';

const baseSx = {
  borderRadius: RADIUS_COIN,
  px: 3.5,
  py: 1.1,
  textTransform: 'none' as const,
  fontFamily: 'Jost, sans-serif',
  fontWeight: 600,
  fontSize: '0.9375rem',
  letterSpacing: '0.005em',
  boxShadow: 'none',
  transition: 'transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease',
  '&:active': { transform: 'translateY(0)' },
};

const disabledSx = {
  '&.Mui-disabled': {
    bgcolor: alpha(NAVY, 0.06),
    color: alpha(NAVY, 0.32),
    boxShadow: 'none',
  },
};

export const PrimaryButton: FC<ButtonProps> = ({ sx, ...rest }) => (
  <Button
    variant="contained"
    disableElevation
    {...rest}
    sx={{
      ...baseSx,
      bgcolor: YELLOW,
      color: NAVY,
      fontWeight: 700,
      boxShadow: `0 4px 12px ${alpha(YELLOW, 0.35)}`,
      '&:hover': {
        bgcolor: YELLOW,
        transform: 'translateY(-1px)',
        boxShadow: `0 8px 20px ${alpha(YELLOW, 0.45)}`,
      },
      ...disabledSx,
      ...sx,
    }}
  />
);

export const SecondaryButton: FC<ButtonProps> = ({ sx, ...rest }) => (
  <Button
    variant="contained"
    disableElevation
    {...rest}
    sx={{
      ...baseSx,
      bgcolor: NAVY,
      color: '#fff',
      fontWeight: 600,
      '&:hover': {
        bgcolor: NAVY,
        transform: 'translateY(-1px)',
        boxShadow: `0 8px 20px ${alpha(NAVY, 0.25)}`,
      },
      ...disabledSx,
      ...sx,
    }}
  />
);

export const BackButton: FC<ButtonProps> = ({ sx, ...rest }) => (
  <Button
    variant="text"
    {...rest}
    sx={{
      ...baseSx,
      bgcolor: 'transparent',
      color: alpha(NAVY, 0.7),
      px: 2.5,
      '&:hover': { bgcolor: alpha(NAVY, 0.04), color: NAVY },
      '&.Mui-disabled': { color: alpha(NAVY, 0.32) },
      ...sx,
    }}
  />
);
